import React from 'react';

import clsx from 'clsx';

import { Stack, Typography, makeStyles } from '@gogame/components';

import ErrorMessage from './ErrorMessage';

const useStyles = makeStyles(() => ({
  compared: {
    '& > *:not(:first-child) fieldset': {
      borderStyle: 'dashed',
    },
  },
}));

const LayoutFilterGeneral = ({ children, label, compared, error, actions }) => {
  const classes = useStyles();

  return (
    <Stack>
      {label != null ? (
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
          minHeight={24}
        >
          {label ? <Typography variant={'overline'}>{label}</Typography> : null}
          {actions?.length ? <Stack direction={'row'}>{actions}</Stack> : null}
        </Stack>
      ) : null}
      <Stack
        spacing={2}
        className={clsx({
          [classes.compared]: compared,
        })}
      >
        {children}
      </Stack>
      {error ? <ErrorMessage>{error?.message}</ErrorMessage> : null}
    </Stack>
  );
};

export default LayoutFilterGeneral;
